import { render, staticRenderFns } from "./order.vue?vue&type=template&id=7ce822ce&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=7ce822ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce822ce",
  null
  
)

export default component.exports